import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "works" }
const _hoisted_2 = {
  class: "works__body",
  "data-scroll-container": ""
}
const _hoisted_3 = { class: "year-info" }
const _hoisted_4 = { class: "year-info__num" }
const _hoisted_5 = { class: "works__list" }
const _hoisted_6 = { class: "works__bg" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "works__img" }
const _hoisted_9 = {
  class: "works__img-inner",
  "data-scroll": "",
  "data-scroll-speed": "0.5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "u-loading" }, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  class: "works__info",
  "data-scroll": "",
  "data-scroll-speed": "1.5"
}
const _hoisted_13 = { class: "works__info-inner" }
const _hoisted_14 = { class: "ttl" }
const _hoisted_15 = { class: "works__next-btn" }
const _hoisted_16 = { class: "works__next-btn-inner" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "year" }
const _hoisted_19 = { class: "year-menu" }
const _hoisted_20 = { class: "year-menu__box" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "2022", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "2021", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", null, "2020", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "2019", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", null, "2018", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "2017", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "2016", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "2015", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "2014", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "2013", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", null, "2012", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, "2011", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", null, "2010", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div class=\"horizontal horizontal--1\"></div><div class=\"horizontal horizontal--2\"></div><div class=\"horizontal horizontal--3\"></div><div class=\"vertical vertical--1\"></div><div class=\"vertical vertical--2\"></div><div class=\"vertical vertical--3\"></div><div class=\"vertical vertical--4\"></div><div class=\"vertical vertical--5\"></div>", 8)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "progress" }, [
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_56 = { class: "u-pc-only" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BackBtn = _resolveComponent("BackBtn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PageHeader, { title: "WORKS" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.selectedYear), 1)
        ]),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedYearWorks, (w) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "works__item",
              key: w.id
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.getImgUrl(w.year, w.id),
                  alt: ""
                }, null, 8, _hoisted_7)
              ]),
              _createVNode(_component_router_link, {
                to: {path:'/works/detail/'+w.id, params:{title: w.title}}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("img", {
                        src: _ctx.getImgUrl(w.year, w.id),
                        alt: ""
                      }, null, 8, _hoisted_11)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", _hoisted_14, _toDisplayString(w.title), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_router_link, {
                to: '/works/'+_ctx.getNextYear()
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _ctx.getImgUrl(_ctx.getNextYear(), _ctx.getNextYear+'-001'),
                    alt: ""
                  }, null, 8, _hoisted_17),
                  _createElementVNode("span", null, "VIEW " + _toDisplayString(_ctx.selectedYear-1) + " WORKS", 1)
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ], 512), [
            [_vShow, _ctx.getNextYear() !== '']
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2022'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2022" }, {
                  default: _withCtx(() => [
                    _hoisted_21,
                    _hoisted_22
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2021'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2021" }, {
                  default: _withCtx(() => [
                    _hoisted_23,
                    _hoisted_24
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2020'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2020" }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _hoisted_26
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2019'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2019" }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2018'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2018" }, {
                  default: _withCtx(() => [
                    _hoisted_29,
                    _hoisted_30
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2017'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2017" }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _hoisted_32
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2016'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2016" }, {
                  default: _withCtx(() => [
                    _hoisted_33,
                    _hoisted_34
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2015'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2015" }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _hoisted_36
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2014'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2014" }, {
                  default: _withCtx(() => [
                    _hoisted_37,
                    _hoisted_38
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2013'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2013" }, {
                  default: _withCtx(() => [
                    _hoisted_39,
                    _hoisted_40
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2012'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2012" }, {
                  default: _withCtx(() => [
                    _hoisted_41,
                    _hoisted_42
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2011'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2011" }, {
                  default: _withCtx(() => [
                    _hoisted_43,
                    _hoisted_44
                  ]),
                  _: 1
                })
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass({'is--current': _ctx.selectedYear == '2010'})
              }, [
                _createVNode(_component_router_link, { to: "/works/2010" }, {
                  default: _withCtx(() => [
                    _hoisted_45,
                    _hoisted_46
                  ]),
                  _: 1
                })
              ], 2)
            ])
          ]),
          _hoisted_47
        ])
      ])
    ]),
    _hoisted_55,
    _createElementVNode("div", _hoisted_56, [
      _createVNode(_component_BackBtn, {
        url: "/",
        text: "HOME"
      })
    ])
  ], 64))
}